import { render, staticRenderFns } from "./exception-dialog.vue?vue&type=template&id=3872058a"
import script from "./exception-dialog.ts?vue&type=script&lang=js&external"
export * from "./exception-dialog.ts?vue&type=script&lang=js&external"
import style0 from "./exception-dialog.vue?vue&type=style&index=0&id=3872058a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports